import { render, staticRenderFns } from "./ProductAnonymousButton.vue?vue&type=template&id=06ba8d4a&"
import script from "./ProductAnonymousButton.vue?vue&type=script&lang=js&"
export * from "./ProductAnonymousButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports